import { app } from "js/namespaces";
import React, { Component } from "reactn";
import {
    DialogActions,
    Button,
    DialogTitle,
    MenuItem,
    Select
} from "@material-ui/core";
import { trackActivity } from "js/core/utilities/utilities";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { TextField } from "@material-ui/core";

const EVENT_CATEGORY = "CancelPlanSurvey";

function FormSelect(props) {
    return (
        <Select
            style={{ width: 300, marginLeft: 45 }}
            variant="outlined"
            value={props.value}
            onChange={props.onChange}
            displayEmpty
            disableUnderline
            className={props.value == "" ? "placeholder" : ""}
            inputProps={{ className: "select-input" }}
        >
            <MenuItem value="" disabled>
                {props.placeholder}
            </MenuItem>
            {props.children}
        </Select>
    );
}

export class DowngradePlanDialog extends Component {
    constructor() {
        super();
        this.state = {
            satisfaction: "",
            future: "",
            reason: "",
            comments: ""
        };

        trackActivity(EVENT_CATEGORY, "Started", null, null, {}, { audit: true });
    }

    submitForm = () => {
        app.user.update({
            cancelPlanSurvey: { ...this.state }
        });
        const props = {
            ...this.state,
            workspace_id: this.props.workspaceId
        };
        trackActivity(EVENT_CATEGORY, "Complete", null, null, props, { audit: true });

        this.props.closeDialog();
    };

    handleChange = (prop, value) => {
        this.setState({ [prop]: value });
    };

    render() {
        let { future, satisfaction, reason, comments } = this.state;

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog} preventClose>
                <DialogTitle>We're sorry to see you go but we'd love to hear why you decided to cancel.</DialogTitle>
                <DialogContent>
                    <h3>
                        <span className="list-num">1. </span>Overall, how satisfied were you with the Beautiful.AI Pro
                        plan?
                    </h3>
                    <FormSelect
                        value={satisfaction}
                        onChange={event => this.handleChange("satisfaction", event.target.value)}
                        placeholder="Choose..."
                    >
                        <MenuItem value="1">Very Satisfied</MenuItem>
                        <MenuItem value="2">Satisfied</MenuItem>
                        <MenuItem value="3">Neutral</MenuItem>
                        <MenuItem value="4">Unsatisfied</MenuItem>
                        <MenuItem value="5">Very Unsatisfied</MenuItem>
                    </FormSelect>

                    <h3>
                        <span className="list-num">2. </span>What was your primary reason for cancelling your
                        subscription?
                    </h3>

                    <FormSelect
                        value={reason}
                        onChange={event => this.handleChange("reason", event.target.value)}
                        placeholder="Choose..."
                    >
                        <MenuItem value="1">No longer need it</MenuItem>
                        <MenuItem value="2">Didn't meet my needs</MenuItem>
                        <MenuItem value="3">Found an alternative</MenuItem>
                        <MenuItem value="4">Too expensive</MenuItem>
                        <MenuItem value="5">Quality was less that expected</MenuItem>
                        <MenuItem value="6">Ease of use was less than expected</MenuItem>
                        <MenuItem value="7">Customer service was less than expected</MenuItem>
                        <MenuItem value="9">Switched to Team Plan</MenuItem>
                        <MenuItem value="8">Other</MenuItem>
                    </FormSelect>

                    <h3>
                        <span className="list-num">3. </span>Would you use the Beautiful.AI Pro plan in the future?
                    </h3>

                    <FormSelect
                        value={future}
                        onChange={event => this.handleChange("future", event.target.value)}
                        placeholder="Choose..."
                    >
                        <MenuItem value="1">Definitely</MenuItem>
                        <MenuItem value="2">Probably</MenuItem>
                        <MenuItem value="3">Not Sure</MenuItem>
                        <MenuItem value="4">Probably Not</MenuItem>
                        <MenuItem value="5">Definitely Not</MenuItem>
                    </FormSelect>

                    <h3>
                        <span className="list-num">4. </span>What could we do to improve Beautiful.AI?
                    </h3>

                    <div style={{ marginLeft: 45 }}>
                        <TextField
                            multiline
                            fullWidth
                            value={comments}
                            onChange={event => {
                                this.setState({ comments: event.target.value });
                            }}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.submitForm} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
